const loggedInReducer = (state = false, action: any) => {
  switch (action.type) {
    case 'user/isLoggedIn':
      return !state;
    default:
      return state;
  }
};

export default loggedInReducer;
